export function capitaliseFirstLetter(value: string | null | undefined): string {
  if (!value) {
    return '';
  }
  return value.substring(0, 1).toUpperCase() + value.substring(1);
}
